<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
   <b-overlay :show="loading" rounded="sm" class="w-100 h-100">
  <div style="height: inherit;">

    <div
      class="body-content-overlay"
      :class="{'show': shallShowUserProfileSidebar || shallShowActiveChatContactSidebar || mqShallShowLeftSidebar}"
      @click="mqShallShowLeftSidebar=shallShowActiveChatContactSidebar=shallShowUserProfileSidebar=false"
    />

    <!-- Main Area -->
    <section class="chat-app-window">

      <!-- Start Chat Logo -->
      <div
        v-if="conversations.length == 0"
        class="start-chat-area"
      >
        <!-- <div class="mb-1 start-chat-icon">
          <feather-icon
            icon="MessageSquareIcon"
            size="56"
          />
        </div>
        <h4
          class="sidebar-toggle start-chat-text"
          @click="startConversation"
        >
          Start Conversation
        </h4> -->
      </div>

      <!-- Chat Content -->
      <div
        v-else
        class="active-chat"
      >
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">

            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">

              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>

              <b-avatar
                size="36"
                class="mr-1 cursor-pointer badge-minimal"
                @click.native="shallShowActiveChatContactSidebar=true"
              />
              <h6 class="mb-0">
                {{ conversations[0].display_name }} 
                ({{ selected_customer}})
              </h6>
            </div>

            <!-- Contact Actions -->
            <div class="d-flex align-items-center">
              
            </div>
          </header>
        </div>

        <!-- User Chat Area -->
        <vue-perfect-scrollbar
          ref="refChatLogPS"
          :settings="perfectScrollbarSettings"
          class="user-chats scroll-area"
          @ps-y-reach-start="loadMoreConversations"
        >
          <chat-log
            :chat-data="conversations"
          />
          <div v-if="uploadedPreviewUrl" class="upload-preview-card">
            <div class="preview-left">
              <!-- Image -->
              <img
                v-if="isImageUpload"
                :src="uploadedPreviewUrl"
                class="preview-media"
                alt="preview"
              />

              <!-- Video -->
              <video
                v-else-if="isVideoUpload"
                :src="uploadedPreviewUrl"
                class="preview-media"
                controls
              />

              <!-- File -->
              <div v-else class="file-chip">
                📄 {{ uploadedFileName }}
              </div>
            </div>

            <div class="preview-right">
              <div class="file-name" :title="uploadedFileName">
                {{ uploadedFileName }}
              </div>

              <b-button
                size="sm"
                variant="outline-danger"
                class="remove-btn"
                @click.prevent="clearUpload"
              >
                ✕ Remove
              </b-button>
            </div>
          </div>
        </vue-perfect-scrollbar>
      
        <!-- Preview -->
        <!-- Message Input -->
        <b-form class="chat-app-form chat-app-form--flex" @submit.prevent="handleSubmit">
          <div class="chat-send-row">
            <draggable
              :list="dropSink"
              :sort="false"
              class="vd-drop-zone"
              tag="div"
            >
              <div
                class="vd-drop-box"
                :class="{ dragging: isDragging }"
                @dragover.prevent="onDragOver"
                @dragenter.prevent="onDragEnter"
                @dragleave.prevent="onDragLeave"
                @drop.prevent="handleDrop"
              >
                <b-input-group class="input-group-merge form-send-message">
                  <b-form-input
                    v-model="chatInputMessage"
                    placeholder="Enter your message (or drag file here)"
                  />
                </b-input-group>
              </div>
            </draggable>

            <b-button
              class="send-btn"
              :class="{ 'send-btn--disabled': isSending }"
              variant="primary"
              type="submit"
              v-if="chatInputMessage || hasUpload"
              :disabled="isSending"
            >
              {{ isSending ? 'Sending...' : 'Send' }}
            </b-button>
          </div>
        </b-form>
      </div>
    </section>

    <!-- Active Chat Contact Details Sidebar -->
    <chat-active-chat-content-details-sidedbar
      :shall-show-active-chat-contact-sidebar.sync="shallShowActiveChatContactSidebar"
      :contact="activeChat.contact || {}"
      :customer="selected_customer"
    />

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <chat-left-sidebar
        :chats-contacts="chatsContacts"
        :active-chat-contact-id="activeChat.contact ? activeChat.contact.id : null"
        :shall-show-user-profile-sidebar.sync="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        @show-user-profile="showUserProfileSidebar"
        @open-chat="openChatOfContact"
        :has-more="hasMore"
        :is-loading="isLoadingContacts"
        @load-more="getContacts"
      />
    </portal>
  </div>
  </b-overlay>
</template>

<script>
  import { computed, watch } from '@vue/composition-api'
import {
  ref, onMounted,onUnmounted, nextTick,
} from '@vue/composition-api'
import {
  BAvatar, BDropdown, BDropdownItem, BForm, BInputGroup, BFormInput, BButton,BOverlay
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import { formatDate } from '@core/utils/filter'
import { $themeBreakpoints } from '@themeConfig'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import store from '@/store'
import ChatLeftSidebar from './ChatLeftSidebar.vue'
import chatStoreModule from './chatStoreModule'
import ChatActiveChatContentDetailsSidedbar from './ChatActiveChatContentDetailsSidedbar.vue'
import ChatLog from './ChatLog.vue'
import useChat from './useChat'
import { postRequest } from '../../../composables/axios.js'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
    // BSV
    BAvatar,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,

    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    ChatLeftSidebar,
    ChatActiveChatContentDetailsSidedbar,
    ChatLog,
  },
  setup() {
    const CHAT_APP_STORE_MODULE_NAME = 'app-chat'
    const dropSink = ref([{ id: 'sink' }]) // required by vuedraggable
    const isDragging = ref(false)
    const loading = ref(false)
    const hasUpload = ref(false)
    const isImageUpload = ref(false)
    const isVideoUpload = ref(false)
    const uploadedFileName = ref(null)
    const uploadedPreviewUrl = ref(null)
    const uploadedFile = ref({
      file: null, 
      base64: null,
      preview: null,
      file_type: null,
      file_name: null,
    })
    const isSending = ref(false)
    const reloadingConversations = ref(false)
    const isProgrammaticScroll = ref(false)
    const dragDepth = ref(0)
    let dragEndTimer = null
    
    const lastWhatsappJson = computed(() => {
      return store.getters['whatsapp/last_whatsapp_json']
    })
    
    watch(lastWhatsappJson, (newVal, oldVal) => {
      if (!newVal) return
      //console.log('📩 last_whatsapp_json changed:', newVal)
      debounceReloadContacts()
      if(Number(newVal.contact_number) == selected_customer.value){
        debounceReloadConversations(activeContact)
      } 
    })

    function debounceReloadConversations(contact) {
      if (reloadingConversations.value) return
      reloadingConversations.value = true
      setTimeout(async () => {
        await getUpdatedConversations(contact)
        reloadingConversations.value = false
        await scrollToBottomInChatLog()
      }, 300)
    }

    async function getUpdatedConversations(contact){
      console.log(contact)
      const offset = conversation_limit * 0
      let cm_waba_id = 108224608741649
      let cm_phone_number_id = 110347678527933
      let rainbow_waba_id = 429471800258486
      let rainbow_phone_number_id = 491732857356103
      let cm_token = "ab1fe120f6c354897e462645890f869e4c3b27a8"
      let rainbow_token = "4b4a666ea63ecd4745f7a4ff52b1401876816b06"
      let payload = {
        waba_id: cm_waba_id,
        phone_number_id: cm_phone_number_id,
        limit: conversation_limit,
        offset,
        phone_number: selected_customer.value
      }
      
      let response = await postRequest("get_conversations",payload,cm_token)
      if(response.request.status == 200){
        if (response?.data?.length) {
          let updated_messages = response.data
          appendOnlyNew(conversations.value,updated_messages)
        } else {
          hasConversationsMore.value = false
        }
      } 
    }

    const keyOf = m => m?.message_id || m?.id
    function appendOnlyNew(existing, incoming) {
      if (!Array.isArray(existing) || !Array.isArray(incoming)) return
    
      // build lookup for fast existence check
      const existingIds = new Set(existing.map(keyOf))
    
      for (const msg of incoming) {
        const k = keyOf(msg)
        if (k && !existingIds.has(k)) {
          existing.push(msg)
          existingIds.add(k)
        }
      }
    }

    function refreshUploadFlags() {
      hasUpload.value = !!uploadedFile.value.base64
      isImageUpload.value = !!uploadedFile.value.file_type && uploadedFile.value.file_type.indexOf('image/') === 0
      isVideoUpload.value = !!uploadedFile.value.file_type && uploadedFile.value.file_type.indexOf('video/') === 0
      if (
        uploadedFile.value &&
        uploadedFile.value.file_type &&
        uploadedFile.value.file_type.indexOf('application/') === 0
      ) {
        uploadedFileName.value = uploadedFile.value.file_name
      }
    }

    function onDragOver(e) { e.preventDefault() }

    function onDragEnter(e) {
      e.preventDefault()
      dragDepth.value += 1
      isDragging.value = true
      if (dragEndTimer) clearTimeout(dragEndTimer)
    }

    function onDragLeave(e) {
      e.preventDefault()
      dragDepth.value = Math.max(0, dragDepth.value - 1)

      // only turn off when fully left the drop zone
      if (dragDepth.value === 0) {
        // small delay avoids flicker when moving between children
        dragEndTimer = setTimeout(() => {
          isDragging.value = false
        }, 30)
      }
    }

    function handleDrop(e) {
      dragDepth.value = 0
      isDragging.value = false
      const file = e.dataTransfer?.files?.[0]
      if (!file) return

      const allowed =
        file.type.startsWith('image/') ||
        file.type.startsWith('video/') ||
        file.type.startsWith('application/')
      if (!allowed) return

      chatInputMessage.value = null
      uploadedPreviewUrl.value = URL.createObjectURL(file)

      const reader = new FileReader()
      reader.onload = () => {
        uploadedFile.value = {
          file,
          base64: reader.result, // ✅ BASE64
          preview: URL.createObjectURL(file),
          file_type: file.type,
          file_name: file.name,
        }
        refreshUploadFlags()
      }
      reader.readAsDataURL(file) // 🔥 BASE64 here
      scrollToBottomInChatLog()
    }

    function resetDragging() {
      dragDepth.value = 0
      isDragging.value = false
      if (dragEndTimer) {
        clearTimeout(dragEndTimer)
        dragEndTimer = null
      }
    }

    function clearUpload() {
      if (uploadedPreviewUrl.value) {
        URL.revokeObjectURL(uploadedPreviewUrl.value)
        uploadedPreviewUrl.value = null
      }
      hasUpload.value = null
      
      uploadedFile.value = {
        file: null,
        base64: null,
        preview: null,
        file_type: null,
        file_name: null,
      }
    }

    // Register module
    if (!store.hasModule(CHAT_APP_STORE_MODULE_NAME)) store.registerModule(CHAT_APP_STORE_MODULE_NAME, chatStoreModule)
    
    const dropZoneEl = ref(null)
    let onWindowDrop = null
    let onWindowDragEnd = null
    let onWindowDragLeave = null
    let onWindowDragOver = null
    onMounted(async () => {
      await nextTick()

      // ✅ 1) Global safety: if user drops outside / leaves window, reset
      onWindowDrop = () => resetDragging()
      onWindowDragEnd = () => resetDragging()
      onWindowDragLeave = e => {
        // when leaving the browser window, clientX/clientY often becomes 0
        if (e.clientX === 0 && e.clientY === 0) resetDragging()
      }
      onWindowDragOver = e => {
        // allow drop anywhere (otherwise drop event may not fire)
        e.preventDefault()
      }

      window.addEventListener('drop', onWindowDrop)
      window.addEventListener('dragend', onWindowDragEnd)
      window.addEventListener('dragleave', onWindowDragLeave)
      window.addEventListener('dragover', onWindowDragOver)

      // ✅ 2) Hard-bind events to the actual drop zone element (most reliable)
      const el = dropZoneEl.value
      if (el) {
        el.addEventListener('dragover', onDragOver)
        el.addEventListener('dragenter', onDragEnter)
        el.addEventListener('dragleave', onDragLeave)
        el.addEventListener('drop', handleDrop)
      }
      const ps = refChatLogPS.value
      const scrollEl = ps?.$el || ps
      if (scrollEl && onScroll) scrollEl.removeEventListener('scroll', onScroll)
    })

    // UnRegister on leave
    onUnmounted(() => {
      // remove window listeners
      if (onWindowDrop) window.removeEventListener('drop', onWindowDrop)
      if (onWindowDragEnd) window.removeEventListener('dragend', onWindowDragEnd)
      if (onWindowDragLeave) window.removeEventListener('dragleave', onWindowDragLeave)
      if (onWindowDragOver) window.removeEventListener('dragover', onWindowDragOver)

      // remove drop zone listeners
      const el = dropZoneEl.value
      if (el) {
        el.removeEventListener('dragover', onDragOver)
        el.removeEventListener('dragenter', onDragEnter)
        el.removeEventListener('dragleave', onDragLeave)
        el.removeEventListener('drop', handleDrop)
      }
      const ps = refChatLogPS.value
      const scrollEl = ps?.$el || ps
      if (scrollEl && onScroll) scrollEl.removeEventListener('scroll', onScroll)
    })

    const { resolveAvatarBadgeVariant } = useChat()

    // Scroll to Bottom ChatLog
    const refChatLogPS = ref(null)
    const scrollToBottomInChatLog = async () => {
      isProgrammaticScroll.value = true
      await nextTick()

      const ps = refChatLogPS.value
      const el = ps?.$el || ps
      if (!el) {
        isProgrammaticScroll.value = false
        return
      }

      if (typeof ps?.update === 'function') ps.update()

      // lock to bottom for a few frames (images/video can change height)
      for (let i = 0; i < 4; i++) {
        await new Promise(r => requestAnimationFrame(r))
        el.scrollTop = el.scrollHeight
        if (typeof ps?.update === 'function') ps.update()
      }

      // release after layout settles
      setTimeout(() => (isProgrammaticScroll.value = false), 150)
    }

    // ------------------------------------------------
    // Chats & Contacts
    // ------------------------------------------------
    const activeContact = ref(null)
    const isLoadingConversations = ref(false)
    const chatsContacts = ref([])
    const contacts = ref([])

    const page = ref(0)
    const limit = 20
    const hasMore = ref(true)
    const isLoadingContacts = ref(false)
    const conversation_page = ref(0)
    const conversation_limit = 20
    const hasConversationsMore = ref(true)
    let conversations = ref([])
    let onScroll = null
    const reloadingContacts = ref(false)
    

    async function loadMoreConversations() {
      if (isProgrammaticScroll.value) return
      if (!activeContact.value) return
      await getConversions(activeContact.value, { prepend: true })
    }

    async function getContacts(){
      if (isLoadingContacts.value || !hasMore.value) return
      isLoadingContacts.value = true

      try {
        let payload = {}
        const offset = page.value * limit
        let cm_waba_id = 108224608741649
        let cm_phone_number_id = 110347678527933
        let rainbow_waba_id = 429471800258486
        let rainbow_phone_number_id = 491732857356103
        let cm_token = "ab1fe120f6c354897e462645890f869e4c3b27a8"
        let rainbow_token = "4b4a666ea63ecd4745f7a4ff52b1401876816b06"
        payload = {
          waba_id: cm_waba_id,
          phone_number_id: cm_phone_number_id,
          limit,
          offset
        }
        let token = cm_token
        let response = await postRequest("get_contact_lists",payload,token)
        if(response.request.status == 200){
          if (response?.data?.length) {
            chatsContacts.value.push(...response.data)
            page.value += 1
            //connectToSockets()
            if (response.data.length < limit) hasMore.value = false
          } else {
            hasMore.value = false
          }
        } 
      } finally {
        isLoadingContacts.value = false
      }
    }

    getContacts()

    function debounceReloadContacts() {
      if (reloadingContacts.value) return
      reloadingContacts.value = true
      setTimeout(async () => {
        chatsContacts.value.splice(0)
        page.value = 0
        hasMore.value = true
        await getContacts()
        reloadingContacts.value = false
      }, 300)
    }

    // ------------------------------------------------
    // Single Chat
    // ------------------------------------------------
    const activeChat = ref({})
    const chatInputMessage = ref(null)
    const selected_customer = ref(null)
    async function openChatOfContact(contact){
      loading.value = true
      activeContact.value = contact
      if(contact.direction == 'out'){
        selected_customer.value = contact.to_number
      } else if (contact.direction == 'in'){
        selected_customer.value = contact.from_number
      }
      conversations.value = []
      conversation_page.value = 0
      hasConversationsMore.value = true

      await nextTick()
      await getConversions(contact, { prepend: false })
      await scrollToBottomInChatLog()
      loading.value = false
    }

    async function getConversions(contact, { prepend } = { prepend: false }){
      if (isLoadingConversations.value || !hasConversationsMore.value) return
      isLoadingConversations.value = true

      // scroll container element
      const ps = refChatLogPS.value
      const scrollEl = ps?.$el || ps
      const oldScrollHeight = scrollEl ? scrollEl.scrollHeight : 0
      const oldScrollTop = scrollEl ? scrollEl.scrollTop : 0
      try{
        const offset = conversation_limit * conversation_page.value
        let cm_waba_id = 108224608741649
        let cm_phone_number_id = 110347678527933
        let rainbow_waba_id = 429471800258486
        let rainbow_phone_number_id = 491732857356103
        let cm_token = "ab1fe120f6c354897e462645890f869e4c3b27a8"
        let rainbow_token = "4b4a666ea63ecd4745f7a4ff52b1401876816b06"
        let payload = {
          waba_id: cm_waba_id ,
          phone_number_id: cm_phone_number_id,
          limit: conversation_limit,
          offset
        }
        payload['phone_number'] = contact.direction == 'in' ? contact.from_number : contact.to_number
        let response = await postRequest("get_conversations",payload,cm_token)
        if(response.request.status == 200){
          if (response?.data?.length) {
            const newMsgs = response.data
            if (prepend) {
              conversations.value = [...newMsgs, ...conversations.value]
            } else {
              conversations.value = [...conversations.value, ...newMsgs]
            }
            conversations.value = conversations.value.sort(
              (a, b) => new Date(a.last_time) - new Date(b.last_time)
            )
            conversation_page.value += 1
            if (newMsgs.length < conversation_limit) hasConversationsMore.value = false
            await nextTick()
            if (prepend && scrollEl) {
              const newScrollHeight = scrollEl.scrollHeight
              scrollEl.scrollTop = oldScrollTop + (newScrollHeight - oldScrollHeight)
            } 
          } else {
            hasConversationsMore.value = false
          }
        }
        mqShallShowLeftSidebar.value = false
      } finally {
        isLoadingConversations.value = false
      }
    }

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    // User Profile Sidebar
    // ? Will contain all details of profile user (e.g. settings, about etc.)
    const profileUserData = ref({})
    // ? Will contain id, name and avatar & status

    const shallShowUserProfileSidebar = ref(false)
    const showUserProfileSidebar = () => {
      store.dispatch('app-chat/getProfileUser')
        .then(response => {
          profileUserData.value = response.data
          shallShowUserProfileSidebar.value = true
        })
    }

    // Active Chat Contact Details
    const shallShowActiveChatContactSidebar = ref(false)

    // UI + SM Devices
    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()
    const startConversation = () => {
      if (store.state.app.windowWidth < $themeBreakpoints.lg) {
        mqShallShowLeftSidebar.value = true
      }
    }

    async function handleSubmit() {
      if (!selected_customer.value) return
      if (isSending.value) return
      isSending.value = true
      try {
        if (uploadedFile.value.base64) {
          await sendMediaMessage()
          clearUpload()
          return
        }

        // 🔹 Text message
        if (chatInputMessage.value) {
          await sendTextMessage()
        }
      } finally {
        isSending.value = false
      }
    }

    async function sendMediaMessage() {
      const cm_waba_id = 108224608741649
      const cm_phone_number_id = 110347678527933
      const cm_token = "ab1fe120f6c354897e462645890f869e4c3b27a8"
      const username = "cloudfit"

      const payload = {
        waba_id: cm_waba_id,
        phone_number_id: cm_phone_number_id,
        recipient: selected_customer.value,
        username,
        file: uploadedFile.value.base64,     // ✅ BASE64
        file_type: uploadedFile.value.file_type,
        file_name: uploadedFile.value.file_name,
      }

      const response = await postRequest("send_media_message", payload, cm_token)
      if (response.request.status !== 200) {
        throw new Error("Failed to send media message")
      }
    }

    async function sendTextMessage(){
      if(chatInputMessage.value){
        let cm_waba_id = 108224608741649
        let cm_phone_number_id = 110347678527933
        let cm_token = "ab1fe120f6c354897e462645890f869e4c3b27a8"
        let username = "cloudfit"
        let payload = {
          waba_id: cm_waba_id,
          phone_number_id: cm_phone_number_id,
          text_message: chatInputMessage.value,
          recipient: selected_customer.value,
          username: username
        }
        let response = await postRequest("send_text_message",payload,cm_token)
        if(response.request.status != 200){
          "should error message for failed message"
        }
      } else {
          "should error message for failed message"
      }
      chatInputMessage.value = null
    }

    return {
      // Filters
      // formatDate,

      // useChat
      resolveAvatarBadgeVariant,

      // Chat & Contacts
      chatsContacts,
      // Single Chat
      refChatLogPS,
      activeChat,
      loading,
      chatInputMessage,
      openChatOfContact,

      // User Profile Sidebar
      profileUserData,
      shallShowUserProfileSidebar,
      showUserProfileSidebar,

      // Active Chat Contact Details
      shallShowActiveChatContactSidebar,

      // UI
      perfectScrollbarSettings,

      // UI + SM Devices
      startConversation,
      mqShallShowLeftSidebar,
      // get contacts
      hasMore,
      isLoadingContacts,
      getContacts,
      conversations,
      loadMoreConversations,
      isLoadingConversations,
      selected_customer,
      sendTextMessage,
      dropSink,
      isDragging,
      hasUpload,
      isSending,
      isImageUpload,
      isVideoUpload,
      uploadedFileName,
      onDragOver,
      onDragEnter,
      onDragLeave,
      handleDrop,
      clearUpload,
      handleSubmit,
      uploadedPreviewUrl
    }
  },
}
</script>

<style scoped>

.chat-send-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;              /* ✅ spacing between input and send button */
  width: 100%;
}

.vd-drop-zone {
  flex: 1;                /* ✅ drop zone takes remaining width */
  min-width: 0;
}

.vd-drop-box{
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 54px;
  overflow: visible !important; /* ✅ don't clip the input */
}

.vd-drop-box.dragging {
  border: 2px dashed #7367f0 !important;
  background: rgba(115, 103, 240, 0.05);
}


.input-row{
  flex: 0 0 auto;               /* ✅ never shrink away */
  min-width: 0;
}
.upload-preview-card {
  display: flex;
  align-items: center;
  gap: 12px;

  padding: 10px 12px;
  border-radius: 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;

  max-width: 100%;
}

.preview-left {
  flex-shrink: 0;
}

/* Image / Video preview */
.preview-media {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 10px;
  background: #000;
}

/* File chip */
.file-chip {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 64px;
  height: 64px;
  border-radius: 10px;

  background: #eef2ff;
  color: #3730a3;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 6px;
}

/* Right side */
.preview-right {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Remove button */
.remove-btn {
  margin-top: 4px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
}

.send-btn {
  flex: 0 0 auto;
  padding-left: 18px;
  padding-right: 18px;
  height: 38px;           /* match input height */
  margin-bottom: 15px;
}
.send-btn--disabled,
.send-btn:disabled {
  background: #d1d5db !important;   /* grey */
  border-color: #d1d5db !important;
  color: #6b7280 !important;
  cursor: not-allowed !important;
  opacity: 1 !important;            /* keep solid grey (not faded) */
  pointer-events: none !important;  /* extra safety */
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>